export enum EPaymentDueDate {
  '30days' = 30,
  '60days' = 60,
  '90days' = 90,
}
